import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const Login = () => import("@/views/pages/Login");
const HomeIndex = () => import("@/views/pages/home/Index");
const ReportIndex = () => import("@/views/pages/report/Index");
const PointIndex = () => import("@/views/pages/point/Index");
const CustomerIndex = () => import("@/views/pages/customer/Index");
const CreateSaleOrderIndex = () => import("@/views/pages/saleOrder/CreateSaleOrder");
const SaleOrderIndex = () => import("@/views/pages/saleOrder/Index");
const SaleOrderDetail = () => import("@/views/pages/saleOrder/Detail");
const EmployeeIndex = () => import("@/views/pages/employee/Index");
const RedeemIndex = () => import("@/views/pages/redeem/Index");
const RedeemHistoryIndex = () => import("@/views/pages/redeem/History");
const RedeemHistoryDetail = () => import("@/views/pages/redeem/HistoryDetail");

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { requiresIsLogin: true },
    },
    {
      path: "/",
      redirect: "/create-sale-order",
      name: "หน้าแรก",
      component: TheContainer,
      meta: { requiresAuth: true, lv: 1, activeUrl: "/home" },
      children: [
        // {
        //   path: "home",
        //   redirect: "/home",
        //   name: "",
        //   component: {
        //     render(c) {
        //       return c("router-view");
        //     },
        //   },
        //   children: [
        //     {
        //       path: "",
        //       name: "หน้าแรก",
        //       component: HomeIndex,
        //       meta: {
        //         requiresAuth: true,
        //         isChildren: true,
        //         activeUrl: "/home",
        //         lv: 2,
        //       },
        //     },
        //   ],
        // },
        {
          path: "report",
          redirect: "/report",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "ประวัติการสั่งซื้อ",
              component: ReportIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/report",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "point",
          redirect: "/point",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "ประวัติคะแนนสะสม",
              component: PointIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/point",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "customer",
          redirect: "/customer",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "ลูกค้า",
              component: CustomerIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/customer",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "create-sale-order",
          redirect: "/create-sale-order",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "สร้างรายการขาย",
              component: CreateSaleOrderIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/create-sale-order",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "sale-order",
          redirect: "/sale-order",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "รายการการขาย",
              component: SaleOrderIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/sale-order",
                lv: 2,
              },
            },
            {
              path: "detail/:id",
              name: "รายละเอียดการขาย",
              component: SaleOrderDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/sale-order",
                lv: 3,
              },
            },
          ],
        },
        {
          path: "employee",
          redirect: "/employee",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "info",
              name: "ข้อมูลพนักงาน",
              component: EmployeeIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/employee",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "redeem",
          redirect: "/redeem",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "history/:memberId",
              name: "รายการแลกของรางวัล",
              component: RedeemHistoryIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/redeem",
                lv: 3,
              },
            },
            {
              path: "history",
              name: "รายการแลกของรางวัล",
              component: RedeemHistoryIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/redeem",
                lv: 3,
              },
            },
            {
              path: "history/detail/:id",
              name: "รายละเอียดแลกของรางวัล",
              component: RedeemHistoryDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/redeem",
                lv: 3,
              },
            },
            {
              path: "",
              name: "แลกของรางวัล",
              component: RedeemIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/redeem",
                lv: 2,
              },
            },
          ],
        },
      ],
    },
  ],
});
